import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { DateRangeFilter, filterByDate, sortRecords, SortableHeader, paginate, Pagination, defaultRange } from './LogTableHelpers';

dayjs.locale('th');

const TYPE_META = {
    individual: { label: 'บุคคล', icon: 'fas fa-user', color: '#17a2b8' },
    organization: { label: 'องค์กร', icon: 'fas fa-university', color: '#6610f2' },
    company: { label: 'บริษัท', icon: 'fas fa-building', color: '#dc3545' }
};
const CONTACT_ICON = {
    phone: 'fas fa-phone', line: 'fab fa-line', email: 'fas fa-envelope',
    fax: 'fas fa-fax', address: 'fas fa-map-marker-alt', facebook: 'fab fa-facebook'
};

function primaryContact(contacts, type) {
    return (contacts || []).find(c => c.type === type && c.value);
}

export class CustomerList extends Component {
    constructor(props) {
        super(props);
        var dr = defaultRange();
        this.state = {
            list: [], loading: true, search: '', typeFilter: '',
            from: dr.from, to: dr.to, sortField: 'createdAt', sortDir: 'desc',
            page: 1, pageSize: 25, useFilter: false
        };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/customer')
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    async del(c) {
        if (!window.confirm('ลบลูกค้า "' + (c.firstName + ' ' + c.lastName).trim() + '" ?')) return;
        try {
            await fetch('api/customer/' + c.id, { method: 'DELETE' });
            this.load();
        } catch {}
    }

    getFiltered() {
        var { list, search, from, to, useFilter, typeFilter } = this.state;
        var r = useFilter ? filterByDate(list, from, to, 'createdAt') : list;
        if (typeFilter) r = r.filter(c => (c.customerType || 'individual') === typeFilter);
        if (search.trim()) {
            var s = search.trim().toLowerCase();
            r = r.filter(c => {
                if ((c.firstName || '').toLowerCase().includes(s)) return true;
                if ((c.lastName || '').toLowerCase().includes(s)) return true;
                if ((c.nickname || '').toLowerCase().includes(s)) return true;
                if ((c.idCard || '').toLowerCase().includes(s)) return true;
                if ((c.passport || '').toLowerCase().includes(s)) return true;
                // search in contacts values + notes
                if ((c.contacts || []).some(x => (x.value || '').toLowerCase().includes(s) || (x.note || '').toLowerCase().includes(s))) return true;
                return false;
            });
        }
        return r;
    }

    render() {
        var { loading, search, from, to, sortField, sortDir, page, pageSize, useFilter, list, typeFilter } = this.state;
        var filtered = this.getFiltered();
        var sorted = sortRecords(filtered, sortField, sortDir);
        var pageItems = paginate(sorted, page, pageSize);

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-3" style={{ flexWrap: 'wrap', gap: 10 }}>
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {list.length} · กรอง {filtered.length} รายการ</p>
                    <Link to="/console/customer/add" className="btn btn-danger"><i className="fas fa-plus"></i> เพิ่มลูกค้า</Link>
                </div>

                <div style={{ background: '#fff', borderRadius: 10, padding: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 }}>
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: 8, marginBottom: 10 }}>
                        <button className={'btn btn-sm ' + (typeFilter === '' ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ typeFilter: '', page: 1 })}>ทั้งหมด</button>
                        {Object.keys(TYPE_META).map(k => {
                            var m = TYPE_META[k];
                            return <button key={k} className={'btn btn-sm ' + (typeFilter === k ? 'btn-dark' : 'btn-outline-secondary')}
                                onClick={() => this.setState({ typeFilter: k, page: 1 })}>
                                <i className={m.icon} style={{ color: m.color }}></i> {m.label}
                            </button>;
                        })}
                        <div className="form-check form-switch ms-2">
                            <input className="form-check-input" type="checkbox" checked={useFilter} onChange={e => this.setState({ useFilter: e.target.checked, page: 1 })} id="cusDateFilter" />
                            <label className="form-check-label" htmlFor="cusDateFilter" style={{ fontSize: 13 }}>กรองตามวันที่เพิ่ม</label>
                        </div>
                        <div className="input-group" style={{ maxWidth: 360, marginLeft: 'auto' }}>
                            <span className="input-group-text" style={{ background: '#fff' }}><i className="fas fa-search" style={{ color: '#aaa' }}></i></span>
                            <input className="form-control" placeholder="ค้นหาชื่อ/เบอร์/อีเมล/เลขบัตร/Passport/หมายเหตุ" value={search} onChange={e => this.setState({ search: e.target.value, page: 1 })} style={{ borderLeft: 'none' }} />
                        </div>
                    </div>
                    {useFilter && <DateRangeFilter from={from} to={to} onChange={(f, t) => this.setState({ from: f, to: t, page: 1 })} />}
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-user-friends" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        ไม่พบรายการ
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0" style={{ fontSize: 14 }}>
                                <thead style={{ background: '#f8f9fa' }}>
                                    <tr>
                                        <SortableHeader label="#" field="id" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={60} />
                                        <SortableHeader label="ประเภท" field="customerType" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={100} />
                                        <SortableHeader label="ชื่อ" field="firstName" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={280} />
                                        <th style={{ width: 260 }}>ติดต่อ</th>
                                        <SortableHeader label="Passport หมดอายุ" field="passportExpiry" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={130} />
                                        <SortableHeader label="สถานะ" field="isActive" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={90} />
                                        <SortableHeader label="เพิ่มโดย" field="createdByName" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={150} />
                                        <SortableHeader label="เพิ่มเมื่อ" field="createdAt" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={130} />
                                        <th style={{ width: 120, textAlign: 'right' }}>จัดการ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageItems.map(c => {
                                        var expiring = c.passportExpiry && dayjs(c.passportExpiry).diff(dayjs(), 'day') < 180 && dayjs(c.passportExpiry).diff(dayjs(), 'day') >= 0;
                                        var expired = c.passportExpiry && dayjs(c.passportExpiry).isBefore(dayjs(), 'day');
                                        var typeMeta = TYPE_META[c.customerType || 'individual'] || TYPE_META.individual;
                                        var phone = primaryContact(c.contacts, 'phone');
                                        var email = primaryContact(c.contacts, 'email');
                                        var line = primaryContact(c.contacts, 'line');
                                        return (
                                            <tr key={c.id} style={{ opacity: c.isActive ? 1 : 0.5 }}>
                                                <td style={{ color: '#aaa' }}>{c.id}</td>
                                                <td>
                                                    <span style={{ background: typeMeta.color, color: '#fff', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', display: 'inline-block' }}>
                                                        <i className={typeMeta.icon}></i> {typeMeta.label}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div style={{ fontWeight: 600 }}>
                                                        <i className="fas fa-user-circle" style={{ color: '#aaa', marginRight: 4 }}></i>
                                                        {c.firstName} {c.lastName}
                                                    </div>
                                                    {c.nickname && <div style={{ fontSize: 12, color: '#888' }}>({c.nickname})</div>}
                                                </td>
                                                <td style={{ fontSize: 12 }}>
                                                    {phone && <div><i className={CONTACT_ICON.phone} style={{ color: '#28a745', fontSize: 11, width: 14 }}></i> <a href={'tel:' + phone.value} style={{ color: '#555', textDecoration: 'none' }}>{phone.value}</a></div>}
                                                    {email && <div><i className={CONTACT_ICON.email} style={{ color: '#dc3545', fontSize: 11, width: 14 }}></i> <span style={{ color: '#555' }}>{email.value}</span></div>}
                                                    {line && <div><i className={CONTACT_ICON.line} style={{ color: '#06c755', fontSize: 11, width: 14 }}></i> <span style={{ color: '#555' }}>{line.value}</span></div>}
                                                    {(c.contacts || []).length > 3 && <div style={{ fontSize: 11, color: '#888' }}>+{c.contacts.length - 3} ช่องทาง</div>}
                                                    {(!phone && !email && !line) && <span style={{ color: '#bbb' }}>-</span>}
                                                </td>
                                                <td style={{ fontSize: 12 }}>
                                                    {c.passportExpiry ? (
                                                        <span style={{ color: expired ? '#dc3545' : (expiring ? '#ff9800' : '#555') }}>
                                                            {dayjs(c.passportExpiry).format('D MMM YYYY')}
                                                            {expired && <i className="fas fa-exclamation-triangle" style={{ marginLeft: 4 }}></i>}
                                                            {!expired && expiring && <i className="fas fa-clock" style={{ marginLeft: 4 }}></i>}
                                                        </span>
                                                    ) : '-'}
                                                </td>
                                                <td>
                                                    {c.isActive ? <span style={{ color: '#28a745', fontSize: 12, fontWeight: 600 }}><i className="fas fa-check-circle"></i> Active</span>
                                                        : <span style={{ color: '#6c757d', fontSize: 12 }}><i className="fas fa-pause-circle"></i> Inactive</span>}
                                                </td>
                                                <td style={{ fontSize: 12 }}>
                                                    {c.createdByName || c.createdBy ? (
                                                        <><i className="fas fa-user" style={{ color: '#aaa', fontSize: 10 }}></i> <span style={{ color: '#555' }}>{c.createdByName || c.createdBy}</span></>
                                                    ) : <span style={{ color: '#bbb' }}>-</span>}
                                                    {(c.updatedBy && c.updatedBy !== c.createdBy) && (
                                                        <div style={{ fontSize: 11, color: '#888' }}><i className="fas fa-edit" style={{ fontSize: 9 }}></i> แก้: {c.updatedByName || c.updatedBy}</div>
                                                    )}
                                                </td>
                                                <td style={{ fontSize: 12, color: '#888', whiteSpace: 'nowrap' }}>{c.createdAt ? dayjs(c.createdAt).format('D MMM YY') : '-'}</td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <div className="d-inline-flex" style={{ gap: 6 }}>
                                                        <Link to={'/console/customer/edit/' + c.id} className="btn btn-sm btn-outline-primary"><i className="fas fa-edit"></i></Link>
                                                        <button className="btn btn-sm btn-outline-danger" onClick={() => this.del(c)}><i className="fas fa-trash"></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <Pagination total={sorted.length} page={page} pageSize={pageSize}
                            onPageChange={p => this.setState({ page: p })}
                            onPageSizeChange={s => this.setState({ pageSize: s, page: 1 })} />
                    </div>
                )}
            </div>
        );
    }
}
